import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "pages/MainPage";
import LoginPage from "pages/LoginPage";
import RegisterPage from "pages/RegisterPage";
import AccountPage from "pages/AccountPage";
import CryptoPricesPage from "pages/CryptoPricesPage";
import AboutPage from "pages/AboutPage";
import BlackjackPage from "pages/BlackjackPage";
import NotFoundPage from "pages/NotFoundPage";
import { AuthProvider } from "context/AuthContext";
// import modals from 'components/modals';
import HeaderCombined from "components/HeaderCombined";
import PromotionsPage from "pages/PromotionsPage";
// import PagePreloader from 'components/PagePreloader';
import PaymentSuccessPage from "pages/PaymentSuccessPage";
import Footer1 from "components/Footer1";

// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app-shell">
          {/* <PagePreloader /> */}
          <HeaderCombined />
          <div className="pb-20"></div>
          <main className="app-shell__content">
            <Routes>
              <Route path="/market" element={<MainPage />} />
              {/* <Route path="/testmodal" element={<modals.Logout />} /> */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/crypto" element={<CryptoPricesPage />} />
              <Route path="/blackjack" element={<BlackjackPage />} />
              <Route path="/" element={<AboutPage />} />

              <Route path="/promotions" element={<PromotionsPage />} />

              <Route path="/payment/success" element={<PaymentSuccessPage />} />

              {/* Catch-all route for 404 Not Found */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer1 />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
